import { apiClient } from "../apiClient";
import { BACKEND_ENDPOINTS, RAG_CHAT_ENDPOINTS } from "../apiEndpoints";

export const uploadRagDocumentApi = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return apiClient.post(
    `${BACKEND_ENDPOINTS.AI_API_BASE_URL}${RAG_CHAT_ENDPOINTS.UPLOAD}`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
};

export const listRagDocumentsApi = () =>
  apiClient.get(`${BACKEND_ENDPOINTS.AI_API_BASE_URL}${RAG_CHAT_ENDPOINTS.DOCUMENTS}`);

export const deleteRagDocumentApi = (docId, filename) =>
  apiClient.delete(`${BACKEND_ENDPOINTS.AI_API_BASE_URL}${RAG_CHAT_ENDPOINTS.DOCUMENTS}/${docId}/${filename}`);

export const ragChatApi = (messages) => {
  const normalizedPayload = Array.isArray(messages)
    ? { messages }
    : { messages: Array.isArray(messages?.messages) ? messages.messages : [] };
  return apiClient.post(`${BACKEND_ENDPOINTS.AI_API_BASE_URL}${RAG_CHAT_ENDPOINTS.CHAT}`, normalizedPayload);
};

export const downloadRagDocumentApi = (docId, filename) =>
  apiClient.get(
    `${BACKEND_ENDPOINTS.AI_API_BASE_URL}${RAG_CHAT_ENDPOINTS.DOCUMENTS}/${docId}/${filename}`,
    null,
    { responseType: "blob" }
  );
